<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'그라운드 게시물 작성'" :back-title="'뒤로가기'" :close-action="beforeCloseAction" />
        <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
            <div @click="setIsTrainingVideo(!isTrainingVideo)" style="margin-top: 12px;" class="training_card" :class="{ 'training_card--active': isTrainingVideo }">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <img :src="require('@/assets/img/camera_icon.png')" alt="" style="width: 58px;">
                        <div>
                            <div style="font-weight: 700; line-height: 24px;">
                                훈련 영상 업로드
                            </div>
                            <div style="font-size: 12px; font-weight: 500; line-height: 18px;">
                                훈련을 직접 촬영하고,<br>
                                전문가의 피드백까지 받아보세요.
                            </div>
                        </div>
                    </div>
                    <div @click.stop style="display:grid; place-items: center;">
                        <CustomSwitchFilterNew :key="trainingSwitchKey" :value="isTrainingVideo" @input="setIsTrainingVideo" />
                    </div>
                </div>
            </div>
            <template v-if="isTrainingVideo">
                <div style="margin-bottom: 59px;">
                    <div style="display: flex; font-size: 14px; justify-content: space-between; align-items: center; margin-top: 36px;">
                        <div style="font-weight: 700; line-height: 20px;">어떤 훈련을 진행했나요?<span style="color: var(--color-main);"> *</span></div>
                        <div style="font-weight: 500; color: #797979;">1개 선택</div>
                    </div>
                    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px 16px; margin-top: 12px;">
                        <div @click="selectTrainingBanner(each)" :class="{ 'active': each.idx === selectedTrainingBannerIdx }" v-for="each, index in trainingBannerList" :key="index + 'training_banner'" class="training_banner_item">
                            <div class="ellipsis" style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.contents.split('|||')[0] }}</div>
                        </div>
                        <div @click="selectTrainingBanner({ idx: -2 })" :class="{ 'active':  selectedTrainingBannerIdx === -2 }" class="training_banner_item">
                            <div class="ellipsis" style="font-weight: 500; font-size: 14px; line-height: 24px;">나만의 개인 훈련 영상 올리기</div>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="!isTrainingVideo" style="font-weight: 700; font-size: 14px; line-height: 20px; margin-bottom: 20px;">자유롭게 이야기해 보세요</div>
            <template v-else>
                <div style="font-weight: 700; font-size: 14px; line-height: 20px;">나의 플레이를 조금 더 섬세하게 잘 작성해 보세요</div>
                <div style="font-size: 12px; font-weight: 700; color: var(--color-main); line-height: 20px; margin-bottom: 10px;">혹시 몰라요? 축구팀 감독님들에게<br>
                    입단 스카우트 제의를 받을 수도 있잖아요! ✨
                </div>
            </template>
            <textarea v-model="sc_contents" :placeholder="setPlaceHolder" style="min-height: 175px; outline: none; resize: none; line-height: 32px; border: none; width: 100%; border-radius: 12px; background-color: #210F030D; padding: 12px;" name="" id=""></textarea>
            <div style="margin-top: 32px;">
                <div style="font-weight: 700; font-size: 14px; line-height: 20px;">사진이나 영상을 같이 넣으면 자세한 피드백을 받아 볼 수 있어요 🚀</div>
                <div v-if="isTrainingVideo" style="font-weight: 700; font-size: 14px; line-height: 20px; color: #808080;">최소 1개의 영상을 추가해주세요.</div>
                <div style="display: flex; margin: 0 -12px; padding: 0 12px; gap: 12px; margin-top: 8px; overflow-x: scroll;" class="hide_scroll">
                    <div v-for="i in [0, 1, 2]" :key="i">
                        <div v-if="!imgSrcArr[i]" @click="showFiles(i)" style="width: 200px; height: 200px; background-color: #210F034D; gap: 8px; flex-direction: column; border-radius: 12px; flex-shrink: 0; display: flex; justify-content: center; align-items: center;">
                            <img style="width: 32px;" :src="require('@/assets/img/request_form_img.png')" alt="">
                            <div style="font-size: 12px; line-height: 24px; font-weight: 700; color: #fff;">이미지 추가</div>
                        </div>
                        <div style="position: relative;" v-else-if="imgSrcArr[i] && !imgSrcArr[i].isVideo">
                            <img style="width: 200px; height: 200px; border-radius: 12px; object-fit: cover;" :src="imgSrcArr[i].src" alt="">
                            <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                            </div>
                        </div>
                        <div style=" position: relative;" v-else-if="imgSrcArr[i] && imgSrcArr[i].isVideo">
                            <video :ref="'videoElement' + i" width="200" height="200" style="border-radius: 12px;" autoplay="false">
                                <source :src="imgSrcArr[i].src + $Util.getStrForVideoPreview()" type="video/mp4">
                            </video>
                            <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 32px; margin-bottom: 30px;">
                <div style="font-weight: 700; font-size: 12px; line-height: 20px;">유튜브에 영상이 있다면 링크를 첨부해주세요</div>
                <div style="position:relative; margin-top: 8px;">
                    <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="position:absolute; left:12px; top: 50%; transform: translateY(-50%); width:20px; height:18px;">
                    <input style="border:0px; height: 56px; border-radius: 12px; outline:none; width:100%; background-color: #210F030D; font-size:16px;color:black; padding: 10px 0px; padding-left:37px;" placeholder="유튜브 URL" @blur="detectLink" @click.stop ref="linkRef" v-model="youtubeLink" />
                </div>
                <div v-if="isShowYoutubeFrame" style="border-radius:12px;overflow:hidden; margin-top: 8px;">
                    <ContentsViewer :contents="youtubeLink" style="" />
                </div>
            </div>
            <div style="display: flex; align-items: center;">
                <input type="file" style="display: none;" ref="file0" data-id="file0" @change="readURL($event)">
                <input type="file" style="display: none;" ref="file1" data-id="file1" @change="readURL($event)">
                <input type="file" style="display: none;" ref="file2" data-id="file2" @change="readURL($event)">
            </div>
        </div>
        <div style="margin-bottom: 20px;">
            <div @click="makeFeed" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">만들기</div>
        </div>
    </div>
</template>

<script>
import CustomSwitchFilterNew from '@/components/common/CustomSwitchFilterNew.vue'
import MercenaryHeader from '@/components/common/MercenaryHeader.vue'
import ContentsViewer from '@/components/common/ContentsViewer.vue'
import { SOCCER_HOW_TYPE, MAIN_TYPE } from '@/Constants'

export default {
    name: 'WriteGroundPost',
    components: { MercenaryHeader, ContentsViewer, CustomSwitchFilterNew },
    props: {
        completeAction: {
            type: Function,
            default: () => {}
        },
        refresh: {
            type: Function,
            default: () => {}
        },
        beforeCompleteAction: {
            type: Function,
            default: () => {}
        },
        refer_training_banner_idx: {
            type: [Number, String],
            default: -1
        },
        setDetectResize: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            imgSrcArr: [null, null, null],
            curIndex: -1,
            youtubeLink: '',
            isShowYoutubeFrame: false,
            sc_contents: '',
            selectedTrainingBannerIdx: -1,
            isTrainingVideo: false,
            trainingBannerList: [],
            trainingSwitchKey: 0,
            isParticipated: false,
            eventNotice: null,
        }
    },
    created() {
        this.getBannerList()
        if (this.refer_training_banner_idx !== -1) {
            this.selectedTrainingBannerIdx = this.refer_training_banner_idx
            this.isTrainingVideo = true
        }
    },
    computed: {
        setPlaceHolder() {
            if (this.isTrainingVideo) {
                return '훈련 영상을 보고 따라 한 뒤 촬영해보세요\n업로드하면서 궁금한 점도 함께 적어주시면, 전문가 피드백 해드려요!'
            } else {
                return '축구에 대한 고민, 일상, 궁금했던 점을 자유롭게 작성해보세요'
            }
        }
    },
    methods: {
        beforeCloseAction() {
            this.$GlobalStore.closeLastModal()
        },
        async getBannerList() {
            const res = await this.$Axios.get('/api/soccerhow/training/banner')

            const bannerList = res.data.training_banner_list
            const isParticipated = res.data.is_participated
            const eventNotice = res.data.event_notice

            this.trainingBannerList = bannerList
            this.isParticipated = isParticipated
            this.eventNotice = eventNotice
        },
        async makeFeed() {
            if (this.sc_contents === '') {
                this.$GlobalStore.showAlert('내용을 입력해주세요.');
                return;
            }
1
            if (/(.)\1{3,}/.test(this.sc_contents)) {
                this.$GlobalStore.showAlert('같은 글자를 4개 이상 반복할 수 없습니다.');
                return
            }

            if (this.sc_contents.length < 5) {
                this.$GlobalStore.showAlert('5자 이상 입력해주세요.')
                return
            }

            if (this.youtubeLink !== '') {
                if (!this.$Util.checkYoutubeLink(this.youtubeLink)) {
                    this.$GlobalStore.showAlert('잘못된 유튜브 링크 입니다.');
                    return;
                }
            }

            if (this.isTrainingVideo && this.trainingBannerList.length > 0 && this.selectedTrainingBannerIdx === -1) {
                this.$GlobalStore.showAlert('어떤 훈련을 진행했는지 선택해주세요.');
                return;
            }

            if (this.isTrainingVideo) {
                const allFalse = this.imgSrcArr.every(value => value === null);
                if (allFalse && this.youtubeLink === '') {
                    this.$GlobalStore.showAlert('최소 한 장의 미디어 또는 유튜브 링크를 추가해주세요')
                    return
                }
            }

            if (this.isTrainingVideo) {
                let isAllVideo = true
                this.imgSrcArr.forEach(item => {
                    if (item) {
                        if (!item.isVideo) {
                            isAllVideo = false
                        }
                    }
                })
                if (!isAllVideo) {
                    alert('훈련 영상은 동영상만 업로드 가능합니다.')
                    return
                }
            }
            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
            })
            const formData = new FormData();
            // const formType = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            formData.append('topic', '')
            formData.append('entredPoint', 0)
            formData.append('isCheckedFastAnswer', '0')
            formData.append('title', '');
            formData.append('contents', this.sc_contents + this.youtubeLink);
            formData.append('type', SOCCER_HOW_TYPE.SINGLE_TRAINING)
            formData.append('mode', 'insert');
            formData.append('isYoutubeExist', (this.youtubeLink !== '' ? '1' : '0'));
            if (this.isTrainingVideo) {
                if (this.selectedTrainingBannerIdx === -2) {
                    formData.append('refer_idx', 0)
                } else {
                    formData.append('refer_idx', this.selectedTrainingBannerIdx)
                }
            }
            for (let i = 0; i < this.imgSrcArr.length; i++) {
                if (this.imgSrcArr[i]) {
                    const curImgSrc = this.imgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        formData.append('file' + i, this.$refs[curImgSrc.id].files[0]);
                    }
                }
            }
            if (this.isTrainingVideo && !this.isParticipated) {
                formData.append('insert_event_notice', 1)
                formData.append('event_notice_idx', this.eventNotice.idx)
            }

            const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) {
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.closeLastModal()
                this.refresh(true, res.data.first_parent_idx)
                if (!this.isTrainingVideo) {
                    this.completeAction(res.data.first_parent_idx)
                    this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: res.data.first_parent_idx })
                }
                if (this.isTrainingVideo) {
                    this.completeAction(res.data.first_parent_idx)
                    this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: res.data.first_parent_idx })
                    // this.$GlobalStore.addModal('CompleteMissonPopup', { isModalBackTransparent: true, transitionName: '', mission_type: MISSION_TYPE.UPLOAD_TRAINING_VIDEO })
                    if (!this.isParticipated) {
                        this.$GlobalStore.addModal('EventPopup', { isModalBackTransparent: true, transitionName: '', event_type: 'complete', notice_idx: this.eventNotice.idx })
                    }
                }
            } else {
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        setIsTrainingVideo(next) {
            const isCloseEventPopup = localStorage.getItem('IS_CLOSE_EVENT_POPUP')
            if (!next) {
                if (this.isParticipated || isCloseEventPopup) {
                    this.isTrainingVideo = false
                } else {
                    this.$GlobalStore.addModal('EventPopup', { isModalBackTransparent: true, transitionName: '', event_type: 'warning', notice_idx: this.eventNotice.idx, completeAction: () => {
                        this.isTrainingVideo = false
                    } })
                    this.trainingSwitchKey += 1
                }
            } else {
                this.isTrainingVideo = true
            }
        },
        shouldAllowTrainingVideoMode() {
            return false
        },
        selectTrainingBanner(each) {
            this.selectedTrainingBannerIdx = each.idx
        },
        detectLink() {
            const isYoutubeLinkComplete = this.$Util.checkYoutubeLink(this.youtubeLink)
            if (isYoutubeLinkComplete) {
                this.isShowYoutubeFrame = true
            }
        },
        showFiles(index) {
            this.curIndex = index
            this.$refs['file' + index].click()
        },
        deleteImg(i) {
            this.$set(this.imgSrcArr, i, null)
            this.$refs['file' + i].value = ''
        },
        readURL(e) {
            const input = e.currentTarget

            if (input.files && input.files[0]) {
                const extension = input.files[0].name.split('.').pop().toLowerCase()

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {
                    const reader = new FileReader()
                    reader.onload = (ev) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.value = ''
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.')
                            return
                        }

                        const data = { src: ev.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 }
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        this.$set(this.imgSrcArr, this.curIndex, data)
                    }
                    reader.readAsDataURL(input.files[0])
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt 만 업로드 가능합니다.')
                }
            }
        }
    }
}
</script>

<style scoped>
.training_banner_item {
    background: #FFFFFF80;
    border-radius: 12px;
    padding: 14px 12px;
    box-shadow: 0px 1px 4px 0px #0000001A;
    border: 2px solid transparent;
}

.training_banner_item:last-child:nth-child(odd) {
    grid-column: span 2;
}

.active {
    border: 2px solid var(--color-main);
    background-color: var(--color-main);
    color: #fff;
}

textarea::placeholder {
    font-weight: 500;
    color: #BBBBBB;
    font-size: 14px;
    line-height: 24px;
}

.training_card {
    background: #210F030D;
    border-radius: 12px;
    padding: 16px 13px;
    box-shadow: 0px 1px 4px 0px #0000001a;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    margin-bottom: 25px;
}
.training_card--active {
    background: #ffead7;          /* 활성 (active) 배경 */
    border-color: var(--color-main);
}
</style>